import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GroupPurchaseCountDown from '@/components/GroupPurchaseCountDown/index';
import Drip from 'drip';
export default {
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    GroupPurchaseCountDown: GroupPurchaseCountDown
  },
  data: function data() {
    return {
      countdownText: '',
      timer: null,
      currentTime: this.item.currentTime || 0,
      endTime: this.item.endTime || 0
    };
  },
  watch: {
    item: {
      handler: function handler(newVal) {
        this.currentTime = newVal.currentTime;
        this.endTime = newVal.endTime;
      },
      deep: true
    }
  },
  methods: {
    gotoGroupPurchase: function gotoGroupPurchase() {
      var _this$item;
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_um7pn5ro_mc',
        cid: 'c_movie_aq5xt2v5',
        groupbuying_id: (_this$item = this.item) === null || _this$item === void 0 ? void 0 : _this$item.dealId,
        needTag: true
      });
      Drip.redirect(this.queryUrl(this.item.detailLink, {
        cityId: Drip.constant.cityId
      }));
    },
    queryUrl: function queryUrl(url, query) {
      var _url = url;
      Object.keys(query).forEach(function (key) {
        if (_url.includes('?')) {
          _url = "".concat(_url, "&").concat(key, "=").concat(query[key]);
        } else {
          _url = "".concat(_url, "?").concat(key, "=").concat(query[key]);
        }
      });
      return _url;
    }
  },
  beforeDestroy: function beforeDestroy() {}
};